import { createContext, useContext, useState, useCallback } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("adults");

  const openBooking = useCallback((t = "adults") => {
    setType(t);
    setOpen(true);
  }, []);

  return (
    <BookingContext.Provider value={{ open, setOpen, type, openBooking }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
